import { createStyles, makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles((theme) =>
  createStyles({
    select: {
      '& .MuiInputBase-root': {
        backgroundColor: theme.palette.background.default,
        height: '4.8rem',
        borderRadius: 4,
      },
      '& .MuiInputBase-input': {
        paddingTop: '1.4rem',
        paddingBottom: '1.5rem',
        cursor: 'pointer',
      },
    },
    loadingSelect: {
      width: '6rem',
    },
    inputText: {
      width: 'auto',
      margin: 0,
      marginTop: '0.8rem',

      '& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button':
        {
          '-webkit-appearance': 'none',
          margin: 0,
        },
      '& input[type=number]': {
        '-moz-appearance': 'textfield',
      },
    },
    tooltip: {
      backgroundColor: theme.palette.secondary.main,
      color: theme.palette.background.paper,
      maxWidth: '28rem',
      fontSize: '1rem',
      padding: theme.spacing(1),
      border: 'none',
      borderRadius: 5,
    },
    infoDrone: {
      display: 'flex',
      alignItems: 'center',
      paddingTop: '0.5rem',
      gap: '1rem',
      maxWidth: '29rem',
      '& .MuiTypography-subtitle1': {
        fontSize: '1rem',
      },
      '& > svg': {
        fontSize: '1.6rem',
        color: theme.palette.error.main,
      },
    },
    infoIntegration: {
      marginTop: '0.6rem',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      '& .MuiTypography-body1': {
        fontSize: '1.2rem',
      },
      '& > svg': {
        width: '1.5rem',
        color: theme.palette.text.secondary,
      },
    },
    tag: {
      marginLeft: '1rem',
      padding: '0.2rem 0.8rem',
      borderRadius: 5,
      backgroundColor: theme.palette.background.default,
      color: theme.palette.text.primary,
      fontSize: '1.1rem',
      fontWeight: 600,
    },
    menuPaper: {
      width: '278px',
    },
    hiddenMenuItem: {
      display: 'none',
    },
    boldText: {
      fontWeight: 600,
    },
  }),
)
